import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-01-22'
        tag='eBay'
        title='A Beginner’s Guide to eBay Listing Promotions'
      >
        <p>
          Inexperienced eBay sellers may find that eBay is a lot more complicated platform than social e-commerce
          marketplaces, wherein visibility within the online community and efforts to re-share own and others' listings
          could be enough to boost sales. On eBay, your listings are up against several others competing for the
          attention of the same target audience. So what exactly could help your items stand out?
        </p>
        <p>
          First, let's start with the practical things you can do to improve your listings for free; You just need to
          allot time and pay attention to details. Apply these tips consistently so that they become second nature to
          you. These could also help your promoted listings perform better.
        </p>

        <p>
          <strong>Craft complete and accurate item specifics.</strong> These are bits of information that describe your
          item (model, style, color, size, manufacturer, etc.). The recommended list of item specifics may depend on the
          category of the item you are listing, so it is always best to check eBay resources from time to time for any
          updates. If you post listings with complete information, you will show up on searches made by potential buyers
          using keywords present in your item specifics.
        </p>

        <p>
          <strong>Ensure that your listing falls under the correct category.</strong> This may seem like a no-brainer,
          but it's always worth the effort to double-check that your item isn't listed under the wrong category. eBay
          also sometimes creates new categories, merges two or more categories, or removes existing ones, so be informed
          of these changes.
        </p>

        <p>
          <strong>Enrich your listing with potent, relevant keywords.</strong> Your title and description should be
          incorporated with keywords shoppers would likely search for. You may use a third-party keyword planner or do
          an old-school DIY search on eBay on your own by determining the important keywords in high-ranking listings of
          items similar to yours.
        </p>

        <p>
          <strong>Price your items competitively.</strong> Some shoppers who use the price filter to narrow their
          searches to their desired price range may look for items on the mid or lower end of the spectrum. Keep this in
          mind in strategizing your price points.
        </p>

        <p>
          <strong>Run a quality check before posting.</strong> Don't forget to proofread your listing for any
          typographical error and misspellings that could instantly make you lose your credibility to a discerning
          potential buyer. Make sure that the title, item specifics, and photos all match. It's easy to mix things up,
          especially when listing several items at once.
        </p>
        <p>
          Now that you get the basics down pat, it's time to explore eBay's in-house promotional program available to
          all Above Standard and Top Rate sellers and shows up on searches with the "Sponsored" label.
        </p>

        <p>
          There are four ways to use <strong>eBay Promoted Listing Standard</strong>, and each one doesn't require a fee
          upfront – you will only be charged when a buyer purchases an item under a promoted listing within 30 days.
          Sellers set the ad rate themselves, usually between 1% to 20% of the item's final price, which may influence
          the placement of your listing against your competitors in searches. Of course, other factors, such as current
          demand for your items and past performance, may likewise come into play.
        </p>
        <p>
          Clueless about how much to set your ad rate? For every listing you'd like to promote, eBay will provide a
          benchmark or guide to help you gauge your rate. You may also change the ad rate throughout the 30 days. You
          will be charged the updated rate closest to when a particular buyer purchases your promoted listing.
        </p>
        <p>
          Expect to make mistakes the first few times you use promoted listing as you are still learning the ropes. The
          bidding aspect and technical side of things – and all those performance metrics – may take some time to get
          used to, especially if you have no relevant experience such as digital marketing.
        </p>
        <p>
          You may promote using any of these options. Whichever you choose, don't forget to review your settings and
          rate before launching your campaign!
        </p>

        <p>
          <strong>1. Sell it Faster through Seller Hub.</strong> This is the simplest to use and ideal for beginners
          because all the seller has to choose the items to promote and decide on the ad rate.
        </p>

        <p>
          <strong>2. Simple Listing Promotion using campaign manager.</strong> This is another simple option for
          beginners who would like to be guided with recommendations from eBay at every step of the process. This
          includes choosing which listings to promote and how much to set the ad rate for.
        </p>

        <p>
          <strong>3. Bulk Listing Selection using campaign manager.</strong> If you have several items to promote, this
          option lets you upload a listing in a .csv file. You may also utilize selection by category.
        </p>

        <p>
          <strong>4. Creating Automated Campaigns.</strong> Seasoned eBay sellers are confident about how this
          promotional program works. This option is best for you as it allows for flexibility in setting your own rules
          that best fit your sales and marketing strategy.
        </p>
        <p>
          Once you launch your campaign or promoted listings, make it a habit to check and analyze the key metrics in
          your performance dashboard for important insights (e.g., impressions, clicks, sales). These will guide your
          future promotional efforts.{' '}
        </p>
        <p>
          <em>Happy listing – and promoting!</em>
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
